module.exports = __webpack_public_path__ + "img/LogoPROASA_Gris.dd4aa866.png";